import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const SvgComponent = (props: SvgProps) => (
    <Svg width={10} height={10} fill="none" {...props}>
        <Path
            stroke="#F9EFFF"
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={1.75}
            d="m1.254 1.25 7.5 7.5M8.754 1.25l-7.5 7.5"
        />
    </Svg>
);
export { SvgComponent as CloseTooltipIcon };
